export class BrandConstants {
  static readonly PRODUCT_NAME = "Paribus AI";
  static readonly HOMEPAGE_URL = "https://www.paribus.ai";
}
